<template>
    <div class="my-4 flex items-center gap-2">
        <span> Preview: </span>
        <div
            class="
                py-2
                px-4
                rounded-full
                inline-flex
                items-center
                my-2
                w-auto
                gap-2
            "
            :style="{
                background: model.color,
                color: isDark(model.color) ? '#fff' : '#000',
            }"
        >
            <ion-icon
                v-if="model.iconMode === ICON_MODE_IONICONS"
                :name="model.icon"
            ></ion-icon>
            <img
                :src="model.icon"
                alt="Icon"
                class="w-[15px] h-[15px]"
                v-if="model.iconMode === ICON_MODE_UPLOAD && model.icon"
            />
            <span v-if="model.iconMode === ICON_MODE_EMOJI">
                {{ model.icon }}
            </span>
            <span>{{ model.name }}</span>
        </div>
    </div>
    <hr />
    <div class="my-4">
        <app-input
            name="name"
            label="Name"
            v-model="model.name"
            placeholder="Name"
            required
        ></app-input>
    </div>
    <div class="flex items-center my-4 gap-2">
        <div>Color:</div>
        <input type="color" name="color" v-model="model.color" />
    </div>
    <div class="my-4">
        <div class="flex items-center">
            <button
                class="rounded-l-md px-4 py-2"
                :class="[
                    model.iconMode === ICON_MODE_IONICONS
                        ? 'bg-primary text-white'
                        : 'bg-gray-100 text-black',
                ]"
                @click="model.iconMode = ICON_MODE_IONICONS"
                type="button"
            >
                Ionicons
            </button>
            <button
                class="px-4 py-2"
                :class="[
                    model.iconMode === ICON_MODE_UPLOAD
                        ? 'bg-primary text-white'
                        : 'bg-gray-100 text-black',
                ]"
                @click="model.iconMode = ICON_MODE_UPLOAD"
                type="button"
            >
                Upload
            </button>
            <button
                class="rounded-r-md px-4 py-2"
                :class="[
                    model.iconMode === ICON_MODE_EMOJI
                        ? 'bg-primary text-white'
                        : 'bg-gray-100 text-black',
                ]"
                @click="model.iconMode = ICON_MODE_EMOJI"
                type="button"
            >
                Emoji
            </button>
        </div>
    </div>
    <div class="my-4" v-show="model.iconMode === ICON_MODE_EMOJI">
        <app-input
            name="icon"
            label="Emoji"
            v-model="model.icon"
            placeholder="Emoji 😊"
        ></app-input>
        <div class="text-xs my-3">
            Use Cmd+Ctrl+Space to open the emoji picker on Mac. Use Win+Period
            on Windows.
        </div>
    </div>
    <div class="my-4" v-show="model.iconMode === ICON_MODE_IONICONS">
        <app-input
            name="icon"
            label="Icon"
            v-model="model.icon"
            placeholder="Icon"
            readonly
        ></app-input>
        <div class="grid grid-cols-12 gap-2 my-2">
            <div
                v-for="icon in Ionicons"
                :key="icon"
                class="
                    flex
                    items-center
                    justify-center
                    rounded-md
                    p-2
                    border border-gray-200
                    cursor-pointer
                    hover:bg-gray-100
                "
                @click="model.icon = icon"
            >
                <ion-icon :name="icon" class="text-[24px]"></ion-icon>
            </div>
        </div>
    </div>
    <div class="my-4" v-show="model.iconMode === ICON_MODE_UPLOAD">
        <input
            type="file"
            ref="fileRef"
            @change="updateUploadIconPreview"
            name="file"
        />
        <div class="text-xs my-2">Recommended size 16x16 pixels</div>
    </div>
    <input type="hidden" name="icon_type" :value="model.iconMode" />
</template>

<script setup>
import { computed, reactive, ref, watch } from "vue";
import { Ionicons } from "./ionicons";

const props = defineProps({
    name: {
        type: String,
        default: "",
    },
    color: {
        type: String,
        default: "#333333",
    },
    icon: {
        type: String,
        default: "american-football-outline",
    },
    mode: {
        type: String,
        default: "ionicons",
    },
});
const ICON_MODE_IONICONS = "ionicons";
const ICON_MODE_UPLOAD = "upload";
const ICON_MODE_EMOJI = "emoji";
const model = reactive({
    name: props.name,
    color: props.color,
    icon: props.icon,
    iconMode: props.mode,
});
const fileRef = ref(null);

watch(
    () => model.iconMode,
    (newVal) => {
        if (newVal !== props.mode) {
            model.icon = "";
        } else {
            model.icon = props.icon;
        }
    }
);

function updateUploadIconPreview(e) {
    const file = fileRef.value.files[0];
    if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
            console.log(e);
            model.icon = e.target.result;
        };
        reader.readAsDataURL(file);
    }
}

function isDark(color) {
    const r = parseInt(color.substr(1, 2), 16);
    const g = parseInt(color.substr(3, 2), 16);
    const b = parseInt(color.substr(5, 2), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness < 125;
}

import AppInput from "../AppInput.vue";
</script>

<style scoped></style>
